module.exports = __webpack_public_path__ + "img/telegram.31122dd1.svg";